<template>
    <div class="notice-icon" @click="showInformList">
        <Badge dot>
            <Icon type="ios-notifications-outline" size="26"></Icon>
        </Badge>
    </div>
</template>
<style>
    .notice-icon {
        margin-right: 20px;
    }

    .notice-icon:hover {
        cursor: pointer;
    }

    .ivu-badge-dot {
        top: 20px !important;
    }

    .ivu-notice {
        width: 450px !important;
        margin-right: 100px !important;
    }
</style>
<script>
    import noticeContent from './noticeContent'

    export default {
        name: 'Notice',
        components: {
            noticeContent,
        },
        data() {
            return {
            }
        },

        methods: {
            showInformList() {
                this.$Notice.open({
                    title: '通知',
                    desc: '这个会被隐藏',
                    duration: 0,
                    render(h) {
                        return h(noticeContent)
                    }
                })
            }
        }
    }
</script>